import { createFileRoute } from "@tanstack/react-router";
import { VerifyEmailPage } from "../components/auth/verify-email-page";
import { leaveIfSignedIn } from "../lib/session-gate";

export const Route = createFileRoute("/verify-email")({
  beforeLoad: leaveIfSignedIn,
  component: () => <VerifyEmailPage />,
});
